import React from "react";
import { css } from "@emotion/react";
import { SmallLoadingSpinner } from "../../../routes/modal-loading-spinner";

export const SwarovskiButtonSpinner: React.FC<{ isPending: boolean }> = ({ isPending }) => {
  if (!isPending) {
    return null;
  }

  return (
    <div
      css={css`
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      `}
    >
      <SmallLoadingSpinner
        color={"white"}
        css={css`
          margin-top: 0;
          margin-right: 6px;
        `}
      />
    </div>
  );
};
